


















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {listBillLadingDebitMoney, listBillLadingDebitQuantity} from "@/modules/shift/services";

@Component({
    name: "LadingDebit"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, type: String }) readonly employeeRowGuid!: string

    ladingDebitQuantity = [] as any;
    ladingDebitMoney = [] as any;
    loading = false;

    async created() {
        this.loading = true;
        try {
            await this.listBillLadingDebtQuantity();
            await this.listBillLadingDebtMoney();
        } catch (e) {
        } finally {
            this.loading = false;
        }
    }

    async listBillLadingDebtQuantity() {
        try {
           const { data } = await listBillLadingDebitQuantity(this.employeeRowGuid);
           this.ladingDebitQuantity = data.datas;
        } catch (e) {
        }
    }

    async listBillLadingDebtMoney() {
        try {
            const { data } = await listBillLadingDebitMoney(this.employeeRowGuid);
            this.ladingDebitMoney = data.datas;
        } catch (e) {
        }
    }
}
